import React from 'react'
import Button from '../button'
import { useTranslations } from '../hooks'
import Icon from '../icon'

const EolIe = () => {
  const { translate } = useTranslations()

  return (
    <div className="container">
      <div className="col-12 d-flex t-light-blue justify-content-between">
        <div className="col-7 u-pl-0">
          <div className="u-pb-96 u-pt-16">
            <svg viewBox="0 0 1000 196.79" style={{ width: '254px', height: '50px' }}>
              <g>
                <path
                  d="M458.75,139.74V55.95c0-0.83,0.55-1.38,1.38-1.38h22.05c0.83,0,1.38,0.55,1.38,1.38v76.9
		c0,24.8,11.3,41.07,36.1,41.07c23.98,0,37.76-17.09,37.76-43.55V55.95c0-0.83,0.55-1.38,1.38-1.38h22.05
		c0.83,0,1.38,0.55,1.38,1.38v136.7c0,0.83-0.55,1.38-1.38,1.38H558.8c-0.83,0-1.38-0.55-1.38-1.38v-14.33h-10.2
		c-9.37,12.13-21.77,18.47-38.03,18.47C482.73,196.79,458.75,178.87,458.75,139.74z M599.3,165.37c-0.28-0.55-0.28-1.38,0.55-1.65
		l17.64-10.2c0.83-0.55,1.65-0.28,2.48,0.83c6.34,11.85,18.19,20.95,36.66,20.95c15.71,0,31.14-6.06,31.14-20.95
		c0-8.82-7.99-13.5-20.12-16.26l-31.7-7.99c-22.32-5.51-34.18-16.26-34.18-37.21c0-25.91,26.73-41.07,52.64-41.07
		c27.29,0,44.65,11.85,55.67,29.49c0.83,1.1,0.55,1.65,0,1.93l-17.91,10.47c-0.83,0.55-1.65,0.28-2.2-0.55
		c-6.06-11.85-17.09-20.12-36.11-20.12c-14.33,0-27.29,7.17-27.29,19.02c0,9.37,4.96,13.78,16.54,16.54l34.18,8.54
		c18.19,4.41,35.28,13.23,35.28,36.38c0,31.42-30.04,43.27-55.4,43.27C629.34,196.79,608.67,184.11,599.3,165.37z M743.96,158.2V78
		c0-0.83-0.55-1.38-1.38-1.38h-23.7c-0.83,0-1.38-0.55-1.38-1.38V55.95c0-0.83,0.55-1.38,1.38-1.38h23.7c0.83,0,1.38-0.55,1.38-1.38
		V17.91c0-0.83,0.55-1.38,1.38-1.38h22.05c0.83,0,1.38,0.55,1.38,1.38v35.28c0,0.83,0.55,1.38,1.38,1.38h30.04
		c0.83,0,1.38,0.55,1.38,1.38v19.29c0,0.83-0.55,1.38-1.38,1.38h-30.04c-0.83,0-1.38,0.55-1.38,1.38v78
		c0,11.3,4.96,15.98,17.09,15.98h15.43c0.83,0,1.38,0.55,1.38,1.38v19.29c0,0.83-0.55,1.38-1.38,1.38h-19.84
		C756.91,194.03,743.96,183.01,743.96,158.2z M876.53,192.65V55.95c0-0.83,0.55-1.38,1.38-1.38h22.05c0.83,0,1.38,0.55,1.38,1.38
		v14.33h10.2c9.37-12.4,21.77-18.47,38.03-18.47c26.46,0,50.44,17.64,50.44,55.4v85.44c0,0.83-0.55,1.38-1.38,1.38h-22.05
		c-0.83,0-1.38-0.55-1.38-1.38v-77.17c0-24.53-11.3-40.79-36.11-40.79c-23.98,0-37.76,17.09-37.76,43.27v74.69
		c0,0.83-0.55,1.38-1.38,1.38H877.9C877.08,194.03,876.53,193.48,876.53,192.65z M282.05,192.65V1.38c0-0.83,0.55-1.38,1.38-1.38
		h68.35c59.53,0,87.64,43,87.64,97.02c0,53.74-28.11,97.02-87.64,97.02h-68.35C282.61,194.03,282.05,193.48,282.05,192.65z
		 M350.96,170.88c44.65,0,61.74-37.48,61.74-73.86c0-36.66-17.09-74.14-61.74-74.14h-42.17c-0.83,0-1.38,0.55-1.38,1.38V169.5
		c0,0.83,0.55,1.38,1.38,1.38H350.96z M821.68,30.04V3.58c0-1.1,0.83-1.93,1.93-1.93h25.36c1.1,0,1.65,0.83,1.65,1.93v26.46
		c0,1.1-0.55,1.65-1.65,1.65h-25.36C822.51,31.7,821.68,31.14,821.68,30.04z M823.88,192.65V55.95c0-0.83,0.55-1.38,1.38-1.38h22.05
		c0.83,0,1.38,0.55,1.38,1.38v136.7c0,0.83-0.55,1.38-1.38,1.38h-22.05C824.44,194.03,823.88,193.48,823.88,192.65z"
                />
                <path
                  d="M39.17,16.17L6.5,72.76c-8.67,15.01-8.67,33.5,0,48.51l32.67,56.59c5.78,10.01,16.45,16.17,28.01,16.17
		l65.35,0c17.33,0,33.34-9.25,42.01-24.25l32.67-56.59c5.78-10.01,5.78-22.33,0-32.34l-32.67-56.59C165.87,9.25,149.86,0,132.53,0
		L67.18,0C55.62,0,44.95,6.16,39.17,16.17z M67.18,10.78l130.69,75.45l0,21.56L67.18,183.25l-18.67-10.78l0-150.91L67.18,10.78z"
                />
              </g>
            </svg>
          </div>
          <h1>{translate('IE_EOL_Header')}</h1>
          <p className="u-pr-56 u-mb-0">{translate('IE_EOL_copy')} </p>
          <div className="d-flex flex-wrap u-pt-24">
            <Button
              className="col-5 u-mr-16"
              text="Microsoft Edge"
              primary
              icon="arrow-right"
              link
              href={translate('IE_EOL-Edge-link')}
            />
            <Button
              className="col-5 u-mr-0"
              text="Google Chrome"
              primary
              icon="arrow-right"
              link
              href={translate('IE_EOL-Chrome-link')}
            />
          </div>
        </div>
        <div className="d-flex align-items-center col-5 u-pr-0">
          <Icon name="market" style={{ height: '214px', width: '214px' }} />
        </div>
      </div>
    </div>
  )
}

export default EolIe
